import { render, staticRenderFns } from "./Form.Docs.Upload.vue?vue&type=template&id=079f7dd0"
import script from "./Form.Docs.Upload.vue?vue&type=script&lang=js"
export * from "./Form.Docs.Upload.vue?vue&type=script&lang=js"
import style0 from "./Form.Docs.Upload.vue?vue&type=style&index=0&id=079f7dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports